import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import inboundEmailKeys from './keyFactory';

const GetInboundEmail = graphql(`
  query InboundEmail($id: ID!) {
    me {
      inboundEmail(id: $id) {
        id
        addressType
        subject
        body
        textBody
        fromEmail
        fromName
        toEmails
        ccEmails
        status
        matchConfidence
        matchedCustomer {
          id
          publicId
          name
        }
        matchedProject {
          id
          publicId
          reference
        }
        assignedProject {
          id
          publicId
          reference
        }
        receivedByUser {
          id
          publicId
          firstName
          lastName
        }
        originalFrom
        originalDate
        createdAt
        updatedAt
      }
    }
  }
`);

const useGetInboundEmail = (id: string | null) => {
  return useQuery({
    queryKey: inboundEmailKeys.detail(id || ''),
    queryFn: () => {
      if (!id) return null;
      return gqlClient.request(GetInboundEmail, { id });
    },
    enabled: !!id,
  });
};

export default useGetInboundEmail;
